import { Box, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

const Legend = styled(Box)(() => ({
  height: "12px",
  width: "12px",
  position: "relative",
}));

const Line = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "15px",
  height: "12px",
  borderBottom: `2px dashed ${theme.palette.shades.neutral[200]}`,
  top: 0,
  left: 0,
  transform: "translateY(-4px) translateX(-2px) rotate(-45deg)",
}));

const TimeSeriesChartLegend = () => (
  <Stack variant="center" direction="row" spacing={1} sx={{ pt: 1.5 }}>
    <Legend>
      <Line />
    </Legend>
    <Typography
      variant="labelMed"
      sx={{ color: "shades.neutral.500", whiteSpace: "nowrap" }}
    >
      Read Average
    </Typography>
  </Stack>
);

export default TimeSeriesChartLegend;
